'use strict';

var $requestPromiseModule = require("request-promise");
var $cookiesModule = require('browser-cookies');

var BluebirdPromise = require("bluebird");
BluebirdPromise.config({cancellation: true});

export default {
  $request: $requestPromiseModule,
  $cookies: $cookiesModule,
  // $api_url : "https://next-solutions.cz/commodity/api/eshop/",
  // $api_url : "https://next-solutions.cz/commodity/api-devel/eshop/",
  // $api_url : "https://next-solutions.cz/commodity/api-beta/eshop/",
  // $api_url : "https://comfort-commodity.eu/api-produkce/eshop/",
  // $api_url : "https://next-solutions.cz/commodity/api-parovani/eshop/",
  // $api_url : "https://next-solutions.cz/commodity/api-delta/eshop/",
    $api_url : process.env.VUE_APP_API_URL,
  get: function ($method) {
    var options = {
        uri: window.API.$api_url + $method + "?XDEBUG_SESSION_START=netbeans-xdebug",
        headers: {
            //'User-Agent': 'HN-WebClient'
        },
        json: true,
        xhrFields: { withCredentials: true },
        crossDomain: true,
        cookies: [
          {
            name: "XDEBUG_SESSION",
            value: "netbeans-xdebug"
          },
          {
            name: "cc_eshop_token",
            value: this.$cookies.get("cc_eshop_token")
          }
        ]
    };
    if (this.$cookies.get("cc_eshop_token") !== null) {
        options.headers['Authorization'] = "Basic " + btoa("1:" + this.$cookies.get("cc_eshop_token"));
        options.headers['AuthToken'] = this.$cookies.get("cc_eshop_token");
    }
    options.headers['TestClient'] = window.testovaci_klient ? "1" : "0";
    return this.$request(options);
  },
  post: function($method, $data) {
    var options = {
        method: 'POST',
        uri: window.API.$api_url + $method + "?XDEBUG_SESSION_START=netbeans-xdebug",
        body: $data,
        json: true,
        xhrFields: { withCredentials: true },
        crossDomain: true,
        headers: {
            //'User-Agent': 'HN-WebClient'
        },
        cookies: [
          {
            name: "XDEBUG_SESSION",
            value: "netbeans-xdebug"
          },
          {
            name: "cc_eshop_token",
            value: this.$cookies.get("cc_eshop_token")
          }
        ]
    };
    if (this.$cookies.get("cc_eshop_token") !== null) {
        options.headers['Authorization'] = "Basic " + btoa("1:" + this.$cookies.get("cc_eshop_token"));
        options.headers['AuthToken'] = this.$cookies.get("cc_eshop_token");
    }
    options.headers['TestClient'] = window.testovaci_klient ? "1" : "0";
    return this.$request(options);
  },
  put: function($method, $data) {
    var options = {
        method: 'PUT',
        uri: window.API.$api_url + $method + "?XDEBUG_SESSION_START=netbeans-xdebug",
        body: $data,
        json: true,
        xhrFields: { withCredentials: true },
        crossDomain: true,
        headers: {
            //'User-Agent': 'HN-WebClient'
        },
        cookies: [
          {
            name: "XDEBUG_SESSION",
            value: "netbeans-xdebug"
          },
          {
            name: "cc_eshop_token",
            value: this.$cookies.get("cc_eshop_token")
          }
        ]
    };
    if (this.$cookies.get("cc_eshop_token") !== null) {
        options.headers['Authorization'] = "Basic " + btoa("1:" + this.$cookies.get("cc_eshop_token"));
        options.headers['AuthToken'] = this.$cookies.get("cc_eshop_token");
    }
    options.headers['TestClient'] = window.testovaci_klient ? "1" : "0";
    return this.$request(options);
  },
  delete: function($method, $data) {
    var options = {
        method: 'DELETE',
        uri: window.API.$api_url + $method + "?XDEBUG_SESSION_START=netbeans-xdebug",
        json: true,
        xhrFields: { withCredentials: true },
        crossDomain: true,
        headers: {
            //'User-Agent': 'HN-WebClient'
        },
        cookies: [
          {
            name: "XDEBUG_SESSION",
            value: "netbeans-xdebug"
          },
          {
            name: "cc_eshop_token",
            value: this.$cookies.get("cc_eshop_token")
          }
        ]
    };
    if (this.$cookies.get("cc_eshop_token") !== null) {
        options.headers['Authorization'] = "Basic " + btoa("1:" + this.$cookies.get("cc_eshop_token"));
        options.headers['AuthToken'] = this.$cookies.get("cc_eshop_token");
    }
    options.headers['TestClient'] = window.testovaci_klient ? "1" : "0";
    return this.$request(options);
  },
  upload: function($method, $formData) {

    return new Promise((resolve, reject) => {
      var $form = $formData;

      var xhr = new XMLHttpRequest();
      xhr.open('POST', window.API.$api_url + $method, true);
      //xhr.setRequestHeader('Content-Type', 'multipart/form-data');
      if (this.$cookies.get("cc_eshop_token") !== null) {
        xhr.setRequestHeader('Authorization', "Basic " + btoa("1:" + this.$cookies.get("cc_eshop_token")));
        xhr.setRequestHeader('AuthToken', this.$cookies.get("cc_eshop_token"));
      }

      xhr.setRequestHeader('TestClient', window.testovaci_klient ? "1" : "0");

      xhr.upload.onprogress = function(e) {
        if (e.lengthComputable) {
          var percentComplete = (e.loaded / e.total) * 100;
          console.log(percentComplete + '% uploaded');
          window.UploadListener.show(percentComplete);
        }
      };
      xhr.onload = function() {
        if (this.status == 200) {
          window.UploadListener.hide();
          var resp = JSON.parse(this.response);
          resolve(resp);
        }
        else {
          reject();
        }
      };
      xhr.send($form);

    });
  },
  download: function($method) {

    return new BluebirdPromise((resolve, reject) => {
      var xhr = new XMLHttpRequest();
      xhr.open('GET', window.api.$api_url + $method, true);
      xhr.responseType = 'arraybuffer';
      if (this.$cookies.get("mpe_token") !== null) {
          xhr.setRequestHeader('AuthToken', this.$cookies.get("cc_eshop_token"));
      }
      xhr.onload = function() {
        if (this.status == 200) {

          var filename = "";
          var disposition = xhr.getResponseHeader('Content-Disposition');
          if (disposition && disposition.indexOf('attachment') !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) filename = matches[1].replace(/['"]/g, '');
          }
          var type = xhr.getResponseHeader('Content-Type');

          var blob = new Blob([this.response], { type: type });
          if (typeof window.navigator.msSaveBlob !== 'undefined') {
            // IE workaround for "HTML7007: One or more blob URLs were revoked by closing the blob for which they were created. These URLs will no longer resolve as the data backing the URL has been freed."
            window.navigator.msSaveBlob(blob, filename);
          }
          else {
            var URL = window.URL || window.webkitURL;
            var downloadUrl = URL.createObjectURL(blob);
            if (filename) {
                // use HTML5 a[download] attribute to specify filename
                var a = document.createElement("a");
                // safari doesn't support this yet
                if (typeof a.download === 'undefined') {
                  window.open(downloadUrl, "_blank");
                }
                else {
                  a.href = downloadUrl;
                  a.download = filename;
                  a.target = "_blank";
                  document.body.appendChild(a);
                  a.click();
                }
            } else {
              window.open(downloadUrl, "_blank");
            }
            setTimeout(function () { URL.revokeObjectURL(downloadUrl); }, 100); // cleanup
          }

          resolve();
        }
        else {
          reject();
        }
      };
      xhr.send();

    });
  },
  $setCookie: function($name, $value, $opts) {
    this.$cookies.set($name, $value, $opts);
  }
}
